__turbopack_export_value__({
  "body-logo-18": "chiefDoctorCard-module-scss-module__8mlb_a__body-logo-18",
  "body-text-12": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-12",
  "body-text-14": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-14",
  "body-text-16": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-16",
  "body-text-18": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-18",
  "body-text-20": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-20",
  "body-text-24": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-24",
  "body-text-24-2": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-24-2",
  "body-text-heading-2": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-heading-2",
  "body-text-heading-3": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-heading-3",
  "body-text-medium-14": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-medium-14",
  "body-text-medium-16": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-medium-16",
  "body-text-medium-18": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-medium-18",
  "body-text-medium2-18": "chiefDoctorCard-module-scss-module__8mlb_a__body-text-medium2-18",
  "body-text2-14": "chiefDoctorCard-module-scss-module__8mlb_a__body-text2-14",
  "body-text2-16": "chiefDoctorCard-module-scss-module__8mlb_a__body-text2-16",
  "btn": "chiefDoctorCard-module-scss-module__8mlb_a__btn",
  "button-primary-text": "chiefDoctorCard-module-scss-module__8mlb_a__button-primary-text",
  "button-text": "chiefDoctorCard-module-scss-module__8mlb_a__button-text",
  "button2-text": "chiefDoctorCard-module-scss-module__8mlb_a__button2-text",
  "buttonContainer": "chiefDoctorCard-module-scss-module__8mlb_a__buttonContainer",
  "buttonsContainer": "chiefDoctorCard-module-scss-module__8mlb_a__buttonsContainer",
  "caption": "chiefDoctorCard-module-scss-module__8mlb_a__caption",
  "card": "chiefDoctorCard-module-scss-module__8mlb_a__card",
  "card-shadow": "chiefDoctorCard-module-scss-module__8mlb_a__card-shadow",
  "cardSchedule": "chiefDoctorCard-module-scss-module__8mlb_a__cardSchedule",
  "cardSubtitle": "chiefDoctorCard-module-scss-module__8mlb_a__cardSubtitle",
  "cardText": "chiefDoctorCard-module-scss-module__8mlb_a__cardText",
  "cardTextSchedule": "chiefDoctorCard-module-scss-module__8mlb_a__cardTextSchedule",
  "cardTextSchedule__row": "chiefDoctorCard-module-scss-module__8mlb_a__cardTextSchedule__row",
  "cardTitle": "chiefDoctorCard-module-scss-module__8mlb_a__cardTitle",
  "cardTitleSurname": "chiefDoctorCard-module-scss-module__8mlb_a__cardTitleSurname",
  "card__inner": "chiefDoctorCard-module-scss-module__8mlb_a__card__inner",
  "effect-menu": "chiefDoctorCard-module-scss-module__8mlb_a__effect-menu",
  "header-1": "chiefDoctorCard-module-scss-module__8mlb_a__header-1",
  "main-container": "chiefDoctorCard-module-scss-module__8mlb_a__main-container",
  "main-footer-container": "chiefDoctorCard-module-scss-module__8mlb_a__main-footer-container",
  "main-header-container": "chiefDoctorCard-module-scss-module__8mlb_a__main-header-container",
  "pdf": "chiefDoctorCard-module-scss-module__8mlb_a__pdf",
  "txt-12-bold": "chiefDoctorCard-module-scss-module__8mlb_a__txt-12-bold",
  "txt-14-bold": "chiefDoctorCard-module-scss-module__8mlb_a__txt-14-bold",
  "txt-14-bold-caps": "chiefDoctorCard-module-scss-module__8mlb_a__txt-14-bold-caps",
  "txt-14-med": "chiefDoctorCard-module-scss-module__8mlb_a__txt-14-med",
  "txt-16-bold": "chiefDoctorCard-module-scss-module__8mlb_a__txt-16-bold",
  "txt-16-med": "chiefDoctorCard-module-scss-module__8mlb_a__txt-16-med",
  "txt-18-bold": "chiefDoctorCard-module-scss-module__8mlb_a__txt-18-bold",
  "txt-18-medium": "chiefDoctorCard-module-scss-module__8mlb_a__txt-18-medium",
  "txt-18-medium-24": "chiefDoctorCard-module-scss-module__8mlb_a__txt-18-medium-24",
  "txt-24-semi": "chiefDoctorCard-module-scss-module__8mlb_a__txt-24-semi",
});
